import { Injectable } from '@angular/core';
import { Poll } from 'src/app/models/poll';
import { PollApiClientService } from '../api/poll-api-client/poll-api-client.service';
import { BaseDetailResolver } from './base-detail.resolver';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PollsService } from '../polls-service/polls-service.service';
import { PollResult } from 'src/app/models/poll-result';
import { NavController } from '@ionic/angular';
import { MERZ_ROUTES } from 'src/app/merz-routes';


@Injectable({
  providedIn: 'root',
})
export class PollFinishResolver extends BaseDetailResolver<Poll> {
  protected override idParam = 'pollId';

  constructor(
    protected service: PollApiClientService,
    protected pollsService: PollsService,
    protected navController: NavController
  ) {
    super();
  }

  override resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const pollId =
    route.paramMap.get(this.idParam) || route.queryParamMap.get(this.idParam);

    return this.service.actionGet({id: pollId}!, 'finish-results').pipe(
      map((pollResult: PollResult) => {
        this.pollsService.pollResult = pollResult;
      }),
      catchError((error) => {
        this.navController.navigateBack([MERZ_ROUTES.homeComplete]);
        return of(undefined);
      })
    );
  }
}
